export var PreventionSectionType;
(function (PreventionSectionType) {
    PreventionSectionType["VIDEO"] = "VIDEO";
    PreventionSectionType["TEXT"] = "TEXT";
    PreventionSectionType["QUIZ"] = "QUIZ";
    PreventionSectionType["EVALUATION"] = "EVALUATION";
})(PreventionSectionType || (PreventionSectionType = {}));
//# sourceMappingURL=prevention-section-type.js.map